(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["veppie-brand-video"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('veppie-brand-video')) {
  customElements.define('veppie-brand-video', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      if (!this.video) return;
      this.motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.handleMotionPreference = () => {
        if (this.motionPreference.matches) {
          this.video.removeAttribute('autoplay');
          this.video.pause();
        } else {
          this.video.setAttribute('autoplay', '');
        }
      };
      this.handleMotionPreference();
      this.motionPreference.addEventListener('change', this.handleMotionPreference);
    }

    disconnectedCallback() {
      this.motionPreference?.removeEventListener('change', this.handleMotionPreference);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["veppie-collection-premium"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
